import * as angular from 'angular';
// return class signment condition
export function getClasses(name: string, formController: angular.IFormController, isDisabled = false) {
    return {
        'disabled': isDisabled,
        'has-error': formController[name]
            && formController[name].$invalid
            && formController.$dirty,
        'has-success': formController[name]
            && formController[name].$valid
            && formController[name].$dirty
    };
}